export default {
  REMINDER: {
    START: "REMINDER.START",
    STOP: "REMINDER.STOP",
  },
};
